export const docCopy = {
  doc_layout_title: "O ponto inicial para aprender Typescript",
  doc_layout_description:
    "Encontre projetos para começar com Typescript: de Angular a React ou Node.js e CLIs.",
  doc_headline: "Recursos para estudo",
  doc_headline_ts_for_js_title: "TS para JS",
  doc_headline_ts_for_js_blurb:
    "Um resumo de Typescript para engenheiros com experiência em JavaScript",
  doc_headline_ts_first_title: "Comece com TS",
  doc_headline_ts_first_blurb:
    "Uma introdução para iniciantes a JavaScript e TypeScript",
  doc_headline_handbook_title: "Manual",
  doc_headline_handbook_blurb: "Referência da linguagem TypeScript",
  doc_headline_examples_title: "Exemplos",
  doc_headline_examples_blurb: "Tutoriais práticos e compreensivos",
  doc_start_a_project: "Comece um projeto",
  doc_start_a_project_desc:
    "Como Typescript é uma extensão do JavaScript, não existe um único molde. Ao invés disso, outros projetos tem seus próprios esqueletos para começar com TypeScript, de acordo com cada contexto. Esses projetos fornecem estruturas básicas que incluem suporte a Typescript.",
  doc_node_npm: "Node com npm",
  doc_node_npm_tsdx_blurb:
    "Ferramenta sem necessidade de configuração para construir bibliotecas TypeScript",
  doc_node_npm_oclif_blurb:
    "Crie ferramentas de linha de comando que seus usuários amam",
  doc_node_npm_gluegun_blurb:
    "Uma maravilhosa coleção de ferramentas para construir aplicativos de linha de comando em TypeScript",
  doc_frameworks: "Frameworks Web",
  doc_frameworks_angular_blurb:
    "Transforme o trabalho de escrever apps lindos em algo alegre e divertido",
  doc_frameworks_ember_blurb: "Framework para desenvolvedores web ambiciosos",
  doc_frameworks_react_blurb:
    "Uma biblioteca JavaScript para construir interfaces de usuário",
  doc_frameworks_vue_blurb: "O framework JavaScript progressivo",
  doc_frameworks_ror_blurb:
    "Framework Web com preferência por convenção ao invés de configuração",
  doc_frameworks_asp_blurb:
    "Framework para aplicações modernas, conectadas à internet e baseadas na nuvem",
  doc_apis: "APIs Node",
  doc_apis_azure_blurb:
    "Construa e distribua dentro do VS Code em questão de minutos",
  doc_apis_feather_blurb: "Framework para aplicações em tempo real e APIs REST",
  doc_apis_graphql_blurb: "Comece seu próprio servidor GraphQL em segundos",
  doc_apis_nest_blurb:
    "Um framework Node.js progressivo para construir aplicações de servidor eficientes e escaláveis",
  doc_apis_node_blurb:
    "Um modelo bem documentado, cortesia do time do TypeScript",
  doc_apis_wechat_blurb: "Use o JSSDK do WeChat com TypeScript",
  doc_apis_loopback_blurb:
    "Um framework Node.js e TypeScript altamente expansível para construir APIs e microsserviços",
  doc_apis_fastify_blurb:
    "Um framework web rápido e de baixo custo computacional para Node.js",
  doc_react: "Projetos em React",
  doc_react_create_blurb: "Crie uma aplicação web moderna com um só comando",
  doc_react_gatsby_blurb:
    "Ajuda desenvolvedores a construir sites e apps web incrivelmente rápidos",
  doc_react_next_blurb: "O framework React",
  doc_react_razzle_blurb:
    "Aplicações universais em JavaScript, renderizadas em servidor - nenhuma configuração necessária",
  doc_react_toolchains_title: "Ferramentas recomendadas",
  doc_react_toolchains_blurb: "Recomendadas pelo time do React",
  doc_apps: "Construindo aplicativos",
  doc_apps_electron_blurb:
    "Construa aplicativos para desktop multi-plataforma com JavaScript, HTML e CSS",
  doc_apps_expo_blurb: "A maneira mais rápida de se construir um app",
  doc_apps_react_native_blurb: "Aprenda uma vez, escreva em qualquer lugar",
  doc_apps_native_script_blurb:
    "Framework de código aberto para construir aplicativos móveis verdadeiramente nativos",
  doc_apps_make_code_blurb:
    "Traga à vida ciência da computação para qualquer estudante com projetos divertidos",
  doc_tooling: "Ferramentas",
  doc_tooling_babel_blurb: "Use JavaScript da próxima geração, hoje",
  doc_tooling_parcel_blurb:
    "Bundler de aplicações web incrivelmente rápido, sem configuração necessária",
  doc_tooling_webpack_blurb: "Agrupe seus recursos, scripts, imagens e estilos",
  doc_learn: "Já conhece TypeScript?",
  doc_learn_3_5_release_notes_title: "Notas de versão",
  doc_learn_3_5_release_notes_blurb: "Notas da versão 3.5",
  doc_learn_handbook_blurb: "Referência da linguagem TypeScript",
  doc_learn_d_ts_title: "Guia d.ts",
  doc_learn_d_ts_blurb: "Aprenda como declarar a forma de JS",
  doc_learn_playground_blurb: "Explore e compartilhe TypeScript online",
}
